import DOMPurify from 'dompurify';

// Its own instance, so the hook below doesn't reach other DOMPurify users in the app.
const purify = DOMPurify();

// In-page anchors and links that hand off to another app stay in the tab.
const SAME_TAB_HREF = /^(#|mailto:|tel:|sms:)/i;

// DOMPurify drops `target`, and documents imported from partners' old pages never had one, so
// every other link is set to open in a new tab here.
purify.addHook('afterSanitizeAttributes', (node) => {
  const href = node.getAttribute('href');

  if (node.tagName !== 'A' || !href || SAME_TAB_HREF.test(href)) return;

  node.setAttribute('target', '_blank');
  node.setAttribute('rel', 'noopener noreferrer');
});

export const sanitizeBodyHtml = (html: string): string => purify.sanitize(html);
